module.exports = __webpack_public_path__ + "95322b8ccd869370fe4ce41d16b10aab.png";